import { render, staticRenderFns } from "./YtOverviewTab.vue?vue&type=template&id=4045fce0&scoped=true&"
import script from "./YtOverviewTab.vue?vue&type=script&lang=js&"
export * from "./YtOverviewTab.vue?vue&type=script&lang=js&"
import style0 from "./YtOverviewTab.vue?vue&type=style&index=0&id=4045fce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045fce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
